"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.globalScrollLock = exports.scrollLock = exports.scrollIntoView = void 0;
function scrollIntoView(element, _a) {
    var _b, _c;
    var { offset = (_c = (_b = document.querySelector('nav')) === null || _b === void 0 ? void 0 : _b.clientHeight) !== null && _c !== void 0 ? _c : 0, center, onlyDown, always, smooth = window.innerWidth >= 600, } = _a === void 0 ? {} : _a;
    if (element && typeof window !== 'undefined') {
        const { top, height } = element.getBoundingClientRect();
        const currentScroll = document.documentElement.scrollTop + document.body.scrollTop;
        const position = currentScroll + top;
        const offsetViewport = window.innerHeight - offset;
        if (!always &&
            top + height <= window.innerHeight &&
            position >= currentScroll + offset) {
            return;
        }
        const centerizeOffset = !center || height > offsetViewport ? 0 : (offsetViewport - height) / 5;
        const targetPosition = position - offset - centerizeOffset;
        if (onlyDown && targetPosition < currentScroll) {
            return;
        }
        setTimeout(() => window.scroll({
            top: targetPosition,
            left: 0,
            behavior: smooth ? 'smooth' : 'auto',
        }));
    }
}
exports.scrollIntoView = scrollIntoView;
const lockIds = new Set();
let scrollPosition = 0;
exports.scrollLock = {
    enable(id) {
        if (lockIds.has(id)) {
            return;
        }
        lockIds.add(id);
        if (lockIds.size > 1) {
            return;
        }
        scrollPosition = window.pageYOffset;
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollPosition}px`;
        document.body.style.width = '100%';
    },
    disable(id) {
        if (!lockIds.has(id)) {
            return;
        }
        lockIds.delete(id);
        if (lockIds.size === 0) {
            document.documentElement.style.removeProperty('overflow');
            document.body.style.removeProperty('overflow');
            document.body.style.removeProperty('position');
            document.body.style.removeProperty('top');
            document.body.style.removeProperty('width');
            window.scrollTo(0, scrollPosition);
        }
    },
};
exports.globalScrollLock = __importStar(require("body-scroll-lock"));
